







import {
  Vue,
  Component,
  Prop,
  Provide,
  Emit,
  Watch,
  Inject,
} from "vue-property-decorator";
import echart from 'echarts';
import Empty from './Empty.vue'
@Component({
  components: {Empty},
})

export default class PieView extends Vue {
    @Prop()
    public name!:string;
    @Prop()
    public width!: Number;
    @Prop()
    public height!: Number;
    @Prop()
    public data!: Array<any>;

    public mychart : any;

    public show: boolean = false;

    @Watch('data',{deep: true})
    public dataChange(newVal : any,oldVal : any) {
         if (!newVal || newVal.length > 0) {
            if(!this.show) {
                this.show = true;
            }
           setTimeout(() => {
                this.draw();
           }, 100);

        } else {
            this.show = false;
        }
    }
    public draw() {
        let dom = document.getElementById(this.name) as any;
        dom.style.height = this.height  + 'px';
        this.mychart = echart.init(dom);
        let seriesData = this.data.map((value,index) => {
            let temp : any= {
                value: value.number,
                name: value.wostatisticalformname
            }
            // if (index == 0) {
            //     temp.selected = true;
            //     temp.label= {show: true}
            //     temp.labelLine = {show: true}
            // }//默认选中例子
            return temp;
        })
        let legendData = this.data.map(value => value.wostatisticalformname);
        let option = {
            tooltip: {
          trigger: 'item',
          // formatter: function(params, ticket, callback) {
          //   let res = `<div><div>${params[0].data.description}：${params[0].value} </div><div>日期：${params[0].data.day}</div></div>`;
          //   return res;
          // },//自定义提示框样式
        },
        legend:
                {
                itemWidth:8,
                orient: "vertical",
                formatter: (name : any) => {
                    // return (name + "" + this.getValue(name))
                    return `{a|${name}}{b|${this.getValue(name)}}`
                },
                y: "center",
                x: "70%",
                data: legendData,
                type : 'scroll',
                textStyle: {
                    rich: {
                        a: {
                            width: 80
                        },
                        b: {}
                    }
                }
            }
            ,
            series: [
                {
                type: 'pie',
                startAngle: 60,
                radius: [30, 50],
                center: ['30%', '50%'],
                selectedMode: 'single',
                legendHoverLink: false,
                hoverAnimation: true,
                label: {
                    show: false,
                    formatter: '{value|{c}}\n{name|{b}}',
                    rich: {
                    value: {
                        fontSize: '20',
                        color: 'black'
                    },
                    name: {
                        color: '#999',
                        height: '18'
                    }
                    }
                },
                data: seriesData,
                }
            ]
        };
        this.mychart.setOption(option);

    }
    public getValue(name : string) {
       for(let value of this.data) {
           let temp = value as any;
             if (temp.wostatisticalformname == name) {
                return temp.number;
            }
       }
    }
    mounted() {
        if (!this.data || this.data.length == 0) {
            this.show = false;
        }
         window.addEventListener('resize',()=> {
            this.mychart.resize();
        })
        const tempThis = this as any;

        if(tempThis.$bus) {
        tempThis.$bus.$on('collapseChange',() => {
            setTimeout(() => {
            this.mychart.resize();
        }, 300);
        });
        }
    }
}
